module.exports = __webpack_public_path__ + "assets/webgl/Ceramic_normal.1001.a5b3df15.jpg";